module.exports = __webpack_public_path__ + "static/media/bytt-no-3.7cab1936.mp3";